import { render, staticRenderFns } from "./examination-download.vue?vue&type=template&id=20a59b48&scoped=true&"
import script from "./examination-download.vue?vue&type=script&lang=js&"
export * from "./examination-download.vue?vue&type=script&lang=js&"
import style0 from "./examination-download.vue?vue&type=style&index=0&id=20a59b48&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a59b48",
  null
  
)

export default component.exports